/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const linkedCardBoxStyle = {
  slide: (theme: Theme, slidesLength: number) => ({
    [theme.breakpoints.up("xs")]: {
      flexBasis: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      flexBasis: `calc(100% / ${Math.min(slidesLength, 2)})`,
    },
    [theme.breakpoints.up("md")]: {
      flexBasis: `calc(100% / ${Math.min(slidesLength, 3)})`,
    },
    [theme.breakpoints.up("lg")]: {
      flexBasis: `calc(100% / ${Math.min(slidesLength, 4)})`,
    },
    padding: "1.5rem 0",
  }),
};

export default linkedCardBoxStyle;
